module.exports = __webpack_public_path__ + "img/precipitation-blank.95f69ee6.png";